import { Component, inject, effect } from '@angular/core';
import { PdfExportService } from '../../services/pdf-export.service';
import { ImpactReportData } from '../../models/impactReportData';
import { ImpactService } from '../../services/impact.service';
@Component({
  selector: 'app-export-pdf',
  templateUrl: './export-pdf.component.html',
  styleUrl: './export-pdf.component.scss',
  standalone: false,
})
export class ExportPdfComponent {
  public graphService = inject(PdfExportService);
  private impactService = inject(ImpactService);

  visible: boolean = false;
  impactReportData?: ImpactReportData;

  constructor() {
    effect(() => {
      this.impactReportData = this.impactService.impactReportData();
    });
  }

  showDialog() {
    this.graphService.updateAvailableCategories(this.impactReportData);
    this.visible = true;
    return this.visible;
  }

  closeDialog() {
    this.visible = false;
    return this.visible;
  }
}
